// pl/views/channelOta.js
export const channelOta = {
  common: {
    listing: "Oferta",
    back: "Wstecz",
    close: "Zamknij",
    cancel: "Anuluj",
    flexible: "Elastyczna",
    noResults: "Brak wyników",
    deleteConn: "Usuń połączenie",
  },
  head: {
    manage: "Zarządzaj: {channel}",
    airbnbConfig: "Ustawienia Airbnb",
    channelOptions: "Opcje kanału",
  },
  picker: {
    placeholder: "Wyszukaj lub wybierz ofertę…",
  },
  loading: {
    status: "Wczytywanie statusu kanału…",
    listings: "Wczytywanie ofert z Airbnb…",
    settings: "Wczytywanie ustawień oferty…",
  },
  accounts: {
    title: "Które konto {channel}?",
    lead: "Jedno konto {channel} jest już połączone. Można dodać do niego tę ofertę albo połączyć inne konto. | Połączone są już {n} konta {channel}. Proszę wybrać, do którego należy ta oferta, albo połączyć kolejne. | Połączonych kont {channel} jest już {n}. Proszę wybrać, do którego należy ta oferta, albo połączyć kolejne.",
    account: "Konto {n}",
    empty: "Brak ofert",
    andMore: "{list} i jeszcze {rest}",
    newTitle: "Połącz kolejne konto {channel}",
    newDesc: "Dla ofert, które znajdują się na innym koncie",
  },
  confirm: {
    title: "Usuń połączenie z {channel}",
    desc: "Kanał zostanie usunięty z channel managera oraz z aktywnych połączeń.",
    coversPre: "To połączenie obejmuje ",
    coversCount: "{count} ofertę | {count} oferty | {count} ofert",
    coversPost: " i zostanie od nich wszystkich odłączone: {list}",
    purgePre: "Usunąć także zaimportowane rezerwacje? Proszę wybrać pokoje ",
    purgeNote: "(można je odzyskać)",
    selectAll: "Wszystko",
    unselectAll: "Wyczyść",
    delete: "Usuń",
    detachOnly: "Odłącz tylko tę ofertę",
    deleteAll: "Usuń i odłącz {count} ofertę | Usuń i odłącz wszystkie {count} oferty | Usuń i odłącz wszystkie {count} ofert",
    deleteWithResv: "Usuń (+{count} rezerwacja) | Usuń (+{count} rezerwacje) | Usuń (+{count} rezerwacji)",
  },
  gone: {
    title: "To połączenie już nie istnieje w kanale",
    desc: "Kanał został usunięty w channel managerze. Aby połączyć go ponownie przez „Połącz teraz”, należy usunąć to połączenie.",
  },
  menu: {
    channelOptDesc: "Włączanie lub wstrzymywanie, edycja mapowania, synchronizacja, pobieranie rezerwacji i usuwanie połączenia.",
    airbnbCfgDesc: "Godziny check-in i check-out, wyprzedzenie, ceny i sprzątanie dla każdej oferty.",
  },
  channel: {
    statusLabel: "Status kanału",
    active: "Aktywny",
    inactive: "Nieaktywny",
    deactivate: "Dezaktywuj kanał",
    activate: "Aktywuj kanał",
    pending: "W trakcie weryfikacji",
    hintPending: "Kanał jest połączony i ma już Twoje dane. Musi jeszcze sprawdzić i zaakceptować Twój obiekt; wtedy aktywuje się sam. Zwykle trwa to kilka dni. Jeśli dłużej, napisz do nas, a sprawdzimy.",
    hintActive: "Kanał jest aktywny: wysyłamy ceny i dostępność. Dezaktywacja wstrzymuje wysyłkę bez utraty mapowania.",
    blockersTitle: "Brakuje czegoś, aby kanał został aktywowany",
    blockersHint: "Naciśnij ponownie „Połącz” w kreatorze – poprawimy to i wyślemy jeszcze raz.",
    hintInactive: "Kanał jest połączony, ale wstrzymany. Aktywacja rozpocznie wysyłanie cen i dostępności.",
    editTitle: "Edytuj kanał",
    editDesc: "Zmiana lub dodanie pokoi i planów taryfowych zmapowanych do tego kanału.",
    editBtn: "Edytuj mapowanie",
    fullSyncTitle: "Pełna synchronizacja",
    fullSyncDesc: "Ponownie wysyła do kanału wszystkie ceny, dostępność i ograniczenia.",
    synced: "Zsynchronizowano",
    sync: "Synchronizuj",
    extractTitle: "Pobierz przyszłe rezerwacje",
    extractDesc: "Import do WACheckin rezerwacji, które już istnieją w kanale.",
    imported: "Zaimportowano",
    extract: "Pobierz",
    resyncTitle: "Importuj rezerwacje ponownie",
    resyncDesc: "Ponownie pobiera wszystkie rezerwacje z kanału i przypisuje je zgodnie z bieżącym mapowaniem. Przydatne, gdy wybrano niewłaściwą ofertę lub brakuje rezerwacji.",
    resync: "Importuj ponownie",
  },
  cfg: {
    emptyNoListings: "Żadna oferta nie została jeszcze dopasowana. Należy przejść do <b>Opcje kanału → Edytuj mapowanie</b>, aby połączyć oferty z Airbnb z jednostkami.",
    emptyNoMapping: "Ten obiekt nie ma jeszcze dopasowanej żadnej oferty z Airbnb. Należy przejść do <b>Opcje kanału → Edytuj mapowanie</b> i dopasować jego ofertę, aby ustawić tutaj godziny i ceny.",
  },
  arrival: {
    section: "Przyjazd i wyjazd",
    lead: "W jakich godzinach i dniach goście mogą się meldować i wymeldowywać.",
    checkInFrom: "Check-in od",
    checkInFromTip: "Najwcześniejsza godzina, o której gość może się zameldować.",
    checkInTo: "Check-in do",
    checkInToTip: "Najpóźniejsza godzina przyjazdu gościa.",
    checkOut: "Check-out",
    checkOutTip: "Najpóźniejsza godzina, o której gość musi opuścić obiekt.",
    unset: "Nie ustawiono",
    daysIn: "Dni z dozwolonym check-in",
    daysInTip: "Dni tygodnia, w których gość może się zameldować.",
    daysOut: "Dni z dozwolonym check-out",
    daysOutTip: "Dni tygodnia, w których gość może się wymeldować.",
  },
  booking: {
    section: "Rezerwacje",
    window: "Okno dostępności",
    windowTip: "Z jakim wyprzedzeniem kalendarz otwiera się na sprzedaż. Airbnb nazywa to „oknem dostępności” (12 miesięcy = 365 dni). To NIE jest maksymalna liczba nocy pobytu.",
    minLead: "Minimalne wyprzedzenie",
    minLeadTip: "Na ile przed przyjazdem można dokonać rezerwacji. Blokuje rezerwacje w ostatniej chwili.",
    maxStay: "Maksymalny pobyt",
    maxStayTip: "Maksymalna liczba nocy w jednej rezerwacji. To „maksymalna liczba nocy” w Airbnb, inna niż okno dostępności.",
    turnover: "Dni między rezerwacjami",
    turnoverTip: "Dni blokowane między check-out a kolejnym check-in, na sprzątanie i przygotowanie.",
  },
  rules: {
    section: "Zasady rezerwacji",
    cancelPolicy: "Zasady anulowania",
    cancelPolicyTip: "Ile gość może odzyskać przy anulowaniu. Elastyczna = łagodniejsza; Restrykcyjna = mniejszy zwrot.",
    whoCanBook: "Kto może rezerwować",
    whoCanBookTip: "Kto może rezerwować od razu, bez wcześniejszej akceptacji gospodarza.",
  },
  prices: {
    section: "Ceny",
    perNight: "Cena za noc",
    weekend: "Cena weekendowa",
    weekendTip: "Cena za piątek i sobotę. Aby nie było różnicy, należy zostawić taką samą jak cena za noc.",
    guestsIncluded: "Goście w cenie",
    guestsIncludedTip: "Liczba gości bez dodatkowych opłat.",
    extraGuest: "Cena za dodatkowego gościa",
    extraGuestTip: "Koszt za każdego dodatkowego gościa, za noc, powyżej liczby zawartej w cenie.",
  },
  cleaning: {
    section: "Sprzątanie",
    notePre: "Należy uzupełnić obie wartości, aby każda rezerwacja obejmowała opłatę za sprzątanie. Opłata przy długim pobycie musi być ",
    noteStrong: "równa lub wyższa",
    notePost: " niż przy krótkim pobycie. Wartość 0 oznacza, że ten rodzaj pobytu nie będzie obciążany opłatą za sprzątanie.",
    long: "Sprzątanie · długi pobyt",
    longTip: "Naliczane przy długich pobytach. Musi być równe lub wyższe niż opłata przy krótkim pobycie.",
    short: "Sprzątanie · krótki pobyt",
    shortTip: "Naliczane przy krótkich pobytach (kilka nocy).",
    error: "Opłata za sprzątanie przy długim pobycie ({sym}{long}) musi być równa lub wyższa niż przy krótkim pobycie ({sym}{short}).",
  },
  tax: {
    section: "Opłata turystyczna",
    lead: "Lokalna opłata pobierana od gościa i rozliczana samodzielnie (nie przez Airbnb). Jeśli nie dotyczy, należy zostawić 0.",
    amount: "Kwota",
    amountTip: "Kwota opłaty. Wartość 0 oznacza brak naliczania.",
    charged: "Naliczanie",
    chargedTip: "Sposób obliczania opłaty: za gościa za noc, za noc lub za gościa.",
    perGuestNight: "Za gościa za noc",
    perNight: "Za noc",
    perGuest: "Za gościa",
    attestation: "Potwierdzam, że te informacje są poprawne i że biorę odpowiedzialność za pobranie oraz rozliczenie tej opłaty.",
  },
  footer: {
    save: "Zapisz ustawienia",
    saving: "Zapisywanie…",
  },
  opts: {
    noticeNoLimit: "Bez limitu (wszystkie terminy)",
    months: "{count} miesiąc | {count} miesiące | {count} miesięcy",
    maxNoLimit: "Bez limitu",
    nights: "{count} noc | {count} noce | {count} nocy",
    maxNights: "Maksimum ({count})",
    cancelModerate: "Umiarkowana",
    cancelFirm: "Stanowcza",
    cancelStrict: "Restrykcyjna",
    instantEveryone: "Każdy gość",
    instantWellReviewed: "Goście z dobrymi opiniami",
    instantVerified: "Zweryfikowana tożsamość",
    instantReviewedVerified: "Opinie + tożsamość",
    leadNone: "Bez wyprzedzenia",
    hours: "{count} godzina | {count} godziny | {count} godzin",
    days: "{count} dzień | {count} dni | {count} dni",
  },
  msg: {
    loadSettingsError: "Nie udało się wczytać ustawień oferty.",
    taxAttestationWarn: "Aby zastosować opłatę turystyczną, należy zaznaczyć pole oświadczenia.",
    saveOk: "Ustawienia Airbnb zostały zapisane i wysłane do kanału.",
    saveError: "Nie udało się zapisać ustawień.",
    statusError: "Nie udało się wczytać statusu kanału.",
    activated: "Kanał został aktywowany.",
    deactivated: "Kanał został dezaktywowany.",
    toggleError: "Nie udało się zmienić statusu kanału.",
    resyncOk: "Ponownie zaimportowane rezerwacje: {imported}.",
    resyncOkWarn: "Ponownie zaimportowane rezerwacje: {imported} ({errors} z ostrzeżeniem).",
    resyncError: "Nie udało się ponownie zaimportować rezerwacji.",
    disconnectError: "Nie udało się usunąć połączenia.",
    fullSyncOk: "Pełna synchronizacja została wysłana.",
    extractOk: "Przyszłe rezerwacje zostały zaimportowane.",
    actionError: "Nie udało się wykonać akcji.",
  },
  rate: {
    apply: "Zastosuj",
    or: "lub",
    usePlan: "użyj jednej ze stawek…",
  },
};
